
let tracking_started = false;

const sal_wiredtrk = {
    start_tracking: () => {
        if (tracking_started) { return; }
        else { tracking_started = true; }

        if (document.location.hostname.indexOf('ddev.site') >= 0) {
            return;
        }

        const l = document.createElement('script'), e = document.getElementsByTagName('script')[0];
        l.async = true;
        l.type = 'text/javascript';
        l.src = 'https://c.leadlab.click/71b999f3956bbef2.js';
        e.parentNode.insertBefore(l, e);
    }
};

export {sal_wiredtrk}
